import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import { editByIdArticulos } from '../../../Services/articuloService'
import { getAllFamilias } from '../../../Services/familiaService'
import { getAllMarcas } from '../../../Services/marcaService'
import { getAllUnidadMedidas } from '../../../Services/unidadMedidaService'

const useEdit = (history, location) => {
  let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
  let rol = token.authorities[0]

  const articulo = location?.state?.articulo

  const [isLoad, setIsLoad] = useState(true)

  const [codigosBarra, setCodigosBarra] = useState([])
  const [familias, setFamilias] = useState([])
  const [marcas, setMarcas] = useState([])
  const [unidadMedidas, setUnidadMedidas] = useState([])

  useEffect(() => {
    if (rol !== 'ROLE_ADMIN') history.goBack()

    if (isLoad) {
      setCodigosBarra(articulo.codigosBarra)
      getAllFamilias(true, 0, '', 100)
        .then((res) => setFamilias(res.data.content))
        .catch((err) => console.log('error'))
      getAllMarcas(true, 0, '', 400)
        .then((res) => {
          setMarcas(res.data.content)
        })
        .catch((err) => console.log('error'))
      getAllUnidadMedidas(true, 0, '', 100)
        .then((res) => {
          setUnidadMedidas(res.data.content)
        })
        .catch((err) => console.log('error'))
      setIsLoad(false)
    } else {
      setIsLoad(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // atributos de articulo
  const formik = useFormik({
    initialValues: {
      nombre: articulo.nombre,
      porcentajeGanancia: articulo.porcentajeGanancia,
      costo: articulo.costo,
      pesable: articulo.pesable,
      balanza: articulo.balanza,
      descripcion: articulo.descripcion,
      precioFinal: articulo.precioFinal,
      codigo: articulo.codigo,
      puntos: articulo.puntos,
      pesoPromedio: articulo.pesoPromedio,
      porcentajePerdida: articulo.porcentajePerdida ?? 0,
      familia: articulo.familia,
      marca: articulo.marca,
      unidadMedida: articulo.unidadMedida,
    },
    validationSchema: Yup.object({
      nombre: Yup.string(),
      costo: Yup.number().min(0, 'El valor debe ser mayor a 0'),
      precioFinal: Yup.number().min(0, 'El valor debe ser mayor a 0'),
      codigo: Yup.string().matches(/^[0-9]+$/, 'Solo números'),
      familia: Yup.object().required('Obligatorio'),
      marca: Yup.object().required('Obligatorio'),
      unidadMedida: Yup.object().required('Obligatorio'),
      porcentajePerdida: Yup.number()
        .min(0, 'Debe ser entre 0 y 100')
        .max(100, 'Debe ser entre 0 y 100'),
    }),
    onSubmit: (values) => editArticuloSubmit(values),
  })

  const handleCodigosBarra = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      const codigoBarraValue = e.target.value.trim()
      if (codigoBarraValue) {
        let codigoBarra = { codigo: codigoBarraValue }
        setCodigosBarra([...codigosBarra, codigoBarra])
        e.target.value = ''
      }
    }
  }

  const deleteCodigoBarra = (e, codigo) => {
    e.preventDefault()
    let codigosBarraFilter = codigosBarra.filter(function (cv) {
      return cv.codigo !== codigo
    })
    setCodigosBarra(codigosBarraFilter)
  }

  const editArticuloSubmit = ({
    nombre,
    costo,
    precioFinal,
    codigo,
    descripcion,
    pesable,
    balanza,
    porcentajeGanancia,
    porcentajePerdida,
    puntos,
    familia,
    marca,
    unidadMedida,
  }) => {
    const isPesable = String(pesable) === 'true'
    //articulo updated
    let articuloUpdated = {
      id: articulo.id,
      nombre,
      costo,
      precioFinal,
      codigo,
      descripcion,
      porcentajeGanancia,
      puntos,
      pesable,
      balanza,
      porcentajePerdida: isPesable ? Number(porcentajePerdida) || 0 : 0,
      codigosBarra,
      familiaId: familia.id,
      marcaId: marca.id,
      unidadMedidaId: unidadMedida.id,
    }

    // actualizo el articulo
    editByIdArticulos(articuloUpdated)
      .then((res) => {
        // restablecer ref
        history.goBack()
      })
      .catch((error) => {
        Swal.fire({
          text: 'Faltan datos o algunos son incorrectos.',
          type: 'info',
          showConfirmButton: false,
          timer: 1500,
        })
      })
  }
  return {
    formik,
    codigosBarra,
    familias,
    marcas,
    unidadMedidas,
    handleCodigosBarra,
    deleteCodigoBarra,
  }
}

export default useEdit